export default "__VITE_ASSET__BA9m8_Zp__"